import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";

export default function PortalProjects() {
  const { data: projects = [] } = useQuery({ queryKey: ["portal-projects"], queryFn: async () => (await api.get("/portal/projects")).data });

  return (
    <div>
      <h1 className="font-display text-2xl font-bold">Projects</h1>
      <p className="text-sm text-muted-foreground">All your projects with Buddy Solution.</p>
      <div className="mt-6 grid gap-4 md:grid-cols-2">
        {projects.length === 0 && <p className="rounded-xl border border-dashed border-border p-8 text-center text-sm text-muted-foreground md:col-span-2">No projects yet.</p>}
        {projects.map((p) => (
          <Link key={p.id} to={`/dashboard/projects/${p.id}`} className="bs-card p-6 hover:shadow-soft" data-testid={`portal-project-${p.id}`}>
            <div className="flex items-start justify-between gap-3">
              <h3 className="font-display text-lg font-bold">{p.title}</h3>
              <Badge variant="secondary">{p.status}</Badge>
            </div>
            <p className="mt-2 text-sm text-muted-foreground line-clamp-2">{p.description}</p>
            <div className="mt-4 flex items-center gap-3">
              <Progress value={p.progress || 0} className="h-2" />
              <span className="text-xs text-muted-foreground">{p.progress || 0}%</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
